import { render, staticRenderFns } from "./OsTrialBanner.vue?vue&type=template&id=729fa40f&scoped=true"
import script from "./OsTrialBanner.vue?vue&type=script&lang=ts"
export * from "./OsTrialBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729fa40f",
  null
  
)

export default component.exports